import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    ChangeOpportunityStatusResultDto,
    EstimateClient,
    OpportunityEstimateView,
    OpportunityStatusAvailableDto
} from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class EstimateService {
    constructor(private readonly client: EstimateClient) {}

    async getFinalEstimateOverview(estimateId: number): Promise<OpportunityEstimateView> {
        return await lastValueFrom(this.client.estimateGetFinalEstimateOverview(estimateId));
    }

    async getAvailableStatus(estimateId: number): Promise<OpportunityStatusAvailableDto[]> {
        return await lastValueFrom(this.client.estimateGetOpportunityStatusAvailable(estimateId));
    }

    async updateEstimateStatus(estimateId: number, statusId: number): Promise<ChangeOpportunityStatusResultDto> {
        return await lastValueFrom(this.client.estimateChangeOpportunityStatus(estimateId, statusId));
    }
}
